import * as React from 'react';
import {currency} from 'constants/loc';
import {FormattedNumber, FormattedMessage} from '@meiko/react-intl';

const defaultOptions = {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
};

export const currencyOptions = {
	style: 'currency',
	currency,
	...defaultOptions,
};

export const percentageOptions = {
	style: 'percent',
	...defaultOptions,
};

export const formatCurrency = (value = 0, options = currencyOptions) => {
	return <FormattedNumber value={value} {...options} />;
};

export const formatPercentage = (value = 0, options = percentageOptions) => {
	return <FormattedNumber value={value} {...options} />;
};

export const formatCount = (value = 0) => {
	return <FormattedMessage id="{num} pcs." values={{num: value}} />;
};
